'use strict';

angular.module('imagetrend.components')
    .directive('hlpIcon', ['Format', function (Format) {
        return {
            restrict: 'AE',
            scope: {
                name: '@?',
                id: '@?',
                alt: '@?',
                title: '@?',
                classes: '@?'
            },
            replace: true,
            transclude: true,
            templateUrl: 'templates/icon/icon.html',
            link: function (scope, elem, attrs, ctrl) {
                if (!attrs.name) { attrs.name = 'icon'; }
                if (!attrs.id) { attrs.id = attrs.name; }
                if (!attrs.alt) { attrs.alt = Format.label(attrs.name); }
                if (!attrs.title) { attrs.title = attrs.alt; }
                if (!attrs.classes) { attrs.classes = 'delete' }
            }
        };
    }])

;